import { render, staticRenderFns } from "./ChatLive.vue?vue&type=template&id=26bbf5ae&scoped=true&"
import script from "./ChatLive.vue?vue&type=script&lang=js&"
export * from "./ChatLive.vue?vue&type=script&lang=js&"
import style0 from "./ChatLive.vue?vue&type=style&index=0&id=26bbf5ae&prod&lang=scss&scoped=true&"
import style1 from "./ChatLive.vue?vue&type=style&index=1&id=26bbf5ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bbf5ae",
  null
  
)

export default component.exports